import {
  EntityMetadata,
  EntityModel,
  FieldDefinition,
  FormModel,
  readEntityModelIncludeExternal,
  ViewModel,
} from '@msdk/definitions'

export function getFieldDef(entityModel: EntityModel, formModel: FormModel, fieldName: string) {
  if (fieldName.includes('FE.')) {
    const cleaned = fieldName.replace('FE.', '')
    return formModel.getFieldDefinition(cleaned)
  } else {
    return entityModel.getFieldDefinition(fieldName)
  }
}

export function getFieldDefIncludeExternal(
  viewModel: ViewModel,
  column: string,
  baseMetadata: EntityMetadata,
): FieldDefinition {
  const fName = viewModel.getFieldNameForColumn(column)
  const joinedEntity = viewModel.getEntityNameForColumn(column)
  const inline = viewModel.columns.find((c) => c.fieldName === column)?.inlineDefinition
  if (inline) return inline

  const model = readEntityModelIncludeExternal(joinedEntity, baseMetadata.msProvider) as EntityModel
  return model.getFieldDefinition(fName)
}
